import React from "react"

import { usePage } from "../../../../hooks/usePage"
import { useCart } from "../../../../hooks/useCart"

export const withCustomerOrdersItem = Component => ({ name = "CustomerOrdersItem", order }) => {
  const { multiAddToCart, loading: cartLoading } = useCart()
  const {
    orders: { additionalOrderNo, additionalDate, additionalStatus, additionalTotalPrice, additionalMore, additionalTracking, additionalOrderAgain },
  } = usePage()

  const handleOrderAgain = () => {
    multiAddToCart(
      order?.lineItems?.map(item => item?.variant?.id),
      1
    )
  }

  Component.displayName = name
  return (
    <Component
      order={order}
      handleOrderAgain={handleOrderAgain}
      cartLoading={cartLoading}
      additionalOrderNo={additionalOrderNo}
      additionalDate={additionalDate}
      additionalStatus={additionalStatus}
      additionalTotalPrice={additionalTotalPrice}
      additionalMore={additionalMore}
      additionalTracking={additionalTracking}
      additionalOrderAgain={additionalOrderAgain}
    />
  )
}
